/**
 * Enum to help classify problems whether they are targeted against E-Täitur (ETIS),
 * Täitmisregister (TR) is not specifically targeted against any system (OVERALL).
 */
export enum ProblemTarget {
  OVERALL = 'OVERALL',
  ETIS = 'ETIS',
  TR = 'TR',
}
